<template>
    <div
        v-for="(item, index) in menu"
        :key="index"
        :class="[
            index == 0
                ? 'max-w-[45%] md:max-w-[25%] md:pr-6 lg:max-w-[15.625rem] lg:pr-10'
                : 'md:border-x md:px-6 lg:px-10 xl:border-l-0',
            isRadioguide() ? 'xl:px-10' : 'xl:px-5',
        ]"
        class="mt-5 box-content border-white/30 md:my-10 xl:my-0 xl:max-w-[10rem] xl:border-x">
        <p class="text-16/132 font-semibold text-ash-200">{{ item.label }}</p>
        <ul class="mt-3 space-y-3 md:mt-5">
            <li
                v-for="link in item.links"
                :key="link.name">
                <NuxtLink
                    :to="link.to"
                    class="block text-14/148 font-medium text-accent-100 transition-colors duration-150 hover:text-ash-200">
                    {{ link.name }}
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import type { FooterMenuGroup } from '~/components/layouts/footer/app-footer.types'

defineProps({
    menu: {
        type: Array as PropType<FooterMenuGroup[]>,
        required: true,
    },
})
</script>
